
    /** Generated by webpack-jst-loader */
    (function() {
      window.JST || (window.JST = {});
      window.JST["app_base/components/phone_multicomplete/templates/token"] = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class='token-imageWrapper f16 image--custom'>\n  <div class='token-image flag "
    + alias3((lookupProperty(helpers,"lowercase")||(depth0 && lookupProperty(depth0,"lowercase"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"abbreviation") : depth0),{"name":"lowercase","hash":{},"data":data,"loc":{"start":{"line":2,"column":31},"end":{"line":2,"column":57}}}))
    + "'></div>\n</div>\n\n<span class='token-text'>"
    + alias3(((helper = (helper = lookupProperty(helpers,"formatted") || (depth0 != null ? lookupProperty(depth0,"formatted") : depth0)) != null ? helper : alias2),(typeof helper === "function" ? helper.call(alias1,{"name":"formatted","hash":{},"data":data,"loc":{"start":{"line":5,"column":25},"end":{"line":5,"column":38}}}) : helper)))
    + "</span>\n\n<div class='token-removeIcon'></div>\n";
},"useData":true});
    }).call(this);
  